import * as yup from 'yup';

const dateRegex = /(^(((0[1-9]|1[0-9]|2[0-8])[/](0[1-9]|1[012]))|((29|30|31)[/](0[13578]|1[02]))|((29|30)[/](0[4,6,9]|11)))[/](19|[2-9][0-9])\d\d$)|(^29[/]02[/](19|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)$)/;
const hourRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

yup.addMethod(yup.string, 'select', function () {
  return this.test('select', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && field.value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'date', function () {
  return this.test('date', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && dateRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid date' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'multiselect', function () {
  return this.test('multiselect', function () {
    const { path, createError } = this;
    const value = document.getElementsByClassName('multiselect-' + path)[0]
      .options.length;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'hour', function () {
  return this.test('hour', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && hourRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid hour' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'endDate', function () {
  return this.test('endDate', function () {
    const { path, createError } = this;
    const error = { path, message: 'Invalid end hour' };
    const hourEndField = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (hourEndField && hourEndField.value) {
        // Date Start
        const dayStart = document
          .getElementsByName('dayStart')[0]
          .getAttribute('date');
        const dateStart = new Date(dayStart);
        const hourStartField = document.getElementsByName('hourStart')[0];
        const [startHour, startMinutes] = hourStartField.value.split(':');
        dateStart.setHours(startHour, startMinutes, 0, 0);
        // Date End
        const dayEnd = document
          .getElementsByName('dayEnd')[0]
          .getAttribute('date');
        const dateEnd = new Date(dayEnd);
        const hourEndField = document.getElementsByName('hourEnd')[0];
        const [endHour, endMinutes] = hourEndField.value.split(':');
        dateEnd.setHours(endHour, endMinutes, 0, 0);
        if (dateStart < dateEnd) {
          resolve(true);
        } else {
          reject(createError(error));
        }
      } else {
        reject(createError(error));
      }
    });
  });
});

const schema = yup.object().shape({
  dayStart: yup.string().date(),
  hourStart: yup.string().hour(),
  dayEnd: yup.string().date(),
  hourEnd: yup
    .string()
    .hour()
    .endDate(),
  typeSchedule: yup.string().select(),
  title: yup
    .string()
    .required()
    .trim(),
  description: yup
    .string()
    .required()
    .trim(),
  employees: yup.string().multiselect()
});

export default schema;
